import { useFinanceSimulationSelector } from "@redux/reducers/deal";
import { getIsLLDJourneySelected } from "@shared/v2/lib/getIsLLDJourneySelected";

export const useIsLLDJourneySelected = () => {
  const financeSimulation = useFinanceSimulationSelector();

  return getIsLLDJourneySelected(financeSimulation.journey);
};
